import { Injectable } from "@angular/core";
import { DiagnosisConditionsService } from "./diagnosis-conditions.service";
import { DiagnosisItem } from "./diagnosis.model";
import { DescriptionService } from "../../description/description.service";
import { Observable } from "rxjs";
import {
  DescriptionFull,
  DescriptionItem,
} from "../../description/description.model";

@Injectable()
export class DiagnosisDescriptionsService {
  private descriptions$: Observable<DescriptionFull>;

  constructor(
    private descriptionsService: DescriptionService,
    private conditionsService: DiagnosisConditionsService,
  ) {
    this.descriptions$ = descriptionsService.getFullDescriptions("diagnosis");
  }

  getDescriptions(items: DiagnosisItem[]): Observable<DescriptionItem[]> {
    return this.descriptions$.switchMap((descriptions) => {
      const addedDescriptions = [];
      const finalDescriptions = [];

      if (items) {
        for (const item of items) {
          const conditionClass = this.conditionsService.getClassForCondition(
            item.condition,
          );
          const descriptionsIdentifiers =
            conditionClass.getDescriptionIdentifiers(item);

          for (const identifier of descriptionsIdentifiers) {
            if (!addedDescriptions.includes(identifier)) {
              addedDescriptions.push(identifier);
              if (descriptions[identifier]) {
                finalDescriptions.push(descriptions[identifier]);
              }
            }
          }
        }
      }

      return Observable.of(finalDescriptions);
    });
  }

  getOrthoDescriptions(condition, options, descriptions) {
    const item = {
      options: options,
    };

    const finalDescriptions = {};

    const conditionClass =
      this.conditionsService.getClassForCondition(condition);
    const descriptionsIdentifiers =
      conditionClass.getDescriptionIdentifiers(item);

    for (const identifier of descriptionsIdentifiers) {
      if (descriptions[identifier]) {
        finalDescriptions[identifier] = descriptions[identifier];
      }
    }

    return finalDescriptions;
  }

  getDescriptionsObservable(): Observable<DescriptionFull> {
    return this.descriptions$;
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/diagnosis/diagnosis-descriptions.service.ts